/* Select.tsx
   Version: 1.0.0
   Date: 2020-12-10
*/

// eslint-disable-next-line
import React from 'react';
import PropTypes from 'prop-types';

export interface SelectProps {
    className?: string
    name: string;
    value: string;
    options: string[];
    onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const Select: React.FC<SelectProps> = (props): JSX.Element => {

    Select.propTypes = {
        className: PropTypes.string,
        name: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        options: PropTypes.array.isRequired,
        onChange: PropTypes.func.isRequired,
    }

    return (
        <select className={props.className ?? 'basic-select'}data-name={props.name} value={props.value} onChange={props.onChange}>
            {props.options.map((option, idx): JSX.Element => <option value={option} key={idx}>{option}</option>)}
        </select>
    );

}

export default Select;
